import type { PublicShowcaseApplication } from './types.js'

export interface FleetTotals {
  published: number
  up: number
  down: number
  flagged: number
  commits30d: number
  pagesWatched: number
}

/**
 * The headline numbers the build log and its share card both print. Every one
 * is a sum over fields the monitor already publishes per product, so the
 * aggregate can never claim more than the rows beneath it.
 */
export function fleetTotals(applications: PublicShowcaseApplication[]): FleetTotals {
  let up = 0
  let down = 0
  let flagged = 0
  let commits30d = 0
  let pagesWatched = 0
  for (const application of applications) {
    if (application.status === 'operational') up += 1
    else if (application.status === 'outage') down += 1
    else if (application.status === 'degraded' || application.status === 'maintenance') flagged += 1
    commits30d += application.activity?.commits30d ?? 0
    pagesWatched += application.previews.length
  }
  return { published: applications.length, up, down, flagged, commits30d, pagesWatched }
}
